import React from "react";
import {
    FontAwesomeIcon,
    FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

import {
    faCircleUser,
    faXmark,
    faMagnifyingGlassPlus,
    faStar,
    faPrint,
} from "@fortawesome/free-solid-svg-icons";

type IconProps = Omit<FontAwesomeIconProps, "icon">;

export const UserIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faCircleUser} {...props} />;
};

export const MagnifyingGlassIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faMagnifyingGlassPlus} {...props} />;
};

export const StarIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faStar} {...props} />;
};

export const CloseIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faXmark} {...props} />;
};

export const PrintIcon = (props: IconProps): JSX.Element => {
    return <FontAwesomeIcon icon={faPrint} {...props} />;
};
